var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSort = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#31C4C0",
    d: "M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBFAF9",
    fillRule: "evenodd",
    d: "M13.605 6.75H16.5a1.5 1.5 0 0 1 1.5 1.5v8.25a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 6 16.5V8.25a1.5 1.5 0 0 1 1.5-1.5h3.045a1.576 1.576 0 0 1 3.06 0m2.895.9h-1.125v.6a.75.75 0 0 1-.75.75h-5.25a.75.75 0 0 1-.75-.75v-.6H7.5a.6.6 0 0 0-.6.6v8.25a.6.6 0 0 0 .6.6h9a.6.6 0 0 0 .6-.6V8.25a.6.6 0 0 0-.6-.6m-3.9-.525a.525.525 0 1 1-1.05 0 .525.525 0 0 1 1.05 0",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBFAF9",
    d: "M8.25 15.3a.45.45 0 0 1 .45-.45h1.35a.45.45 0 0 1 0 .9H8.7a.45.45 0 0 1-.45-.45m0-2.25a.45.45 0 0 1 .45-.45h4.35a.45.45 0 0 1 0 .9H8.7a.45.45 0 0 1-.45-.45m0-2.25a.45.45 0 0 1 .45-.45h6.6a.45.45 0 0 1 0 .9H8.7a.45.45 0 0 1-.45-.45"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSort);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/sort.5aaade7b.svg";